import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function StudiesImaging({ item, index }) {
  return <QuestionHOC item={item} index={index}>
    <div className="row">
      <div className="col">
        <p className="mt-3" style={{ fontSize: 18, fontWeight: 'bold' }}>Studies/Imaging</p>
        <p>MRI of the cervical spine taken at ACME Advanced Imaging: C6-7, C7-T1 left sided foraminal stenosis and C5-6 central protrusion</p>
      </div>
    </div>
  </QuestionHOC>
}